import React from 'react';
import { ArcaPlan } from '../../constants/arcaPlans';
import NewPlanSummaryTable from './NewPlanSummaryTable';
import NewPlanAdvice from './NewPlanAdvice';
import { PlanReturnView } from '../../utils/transferReturns';

interface NewPlanAnalysisProps {
	resolvedPlan: ArcaPlan;
	/** Rentabilidad y comisión de comparsa; `null` = sin datos. */
	planReturn: PlanReturnView | null;
	translate: (key: string) => string;
}

/**
 * Card "Tu plan elegido" para plan nuevo (sin origen): tabla de datos del plan y, debajo, el
 * consejo de asesor. Espejo de `SituationAnalysis` del traspaso, pero sin la columna de
 * comparación ni el coloreado verde/rojo (no hay plan actual contra el que medir).
 */
const NewPlanAnalysis: React.FC<NewPlanAnalysisProps> = ({
	resolvedPlan,
	planReturn,
	translate
}) => (
	<div className="surface-card p-5 space-y-4">
		<NewPlanSummaryTable
			resolvedPlan={resolvedPlan}
			planReturn={planReturn}
			translate={translate}
		/>
		{/* El consejo depende de la comisión y la rentabilidad: sin ellas, no hay consejo. */}
		{planReturn && planReturn.managementFeePct !== null && (
			<NewPlanAdvice
				managementFeePct={planReturn.managementFeePct}
				annualPct={planReturn.annualPct}
				translate={translate}
			/>
		)}
	</div>
);

export default NewPlanAnalysis;
